import {call, fork, put} from "redux-saga/effects";
import {trackError} from "../../store/log/actions";
import {LogLevel} from "../../store/log/types";
import {delay} from "redux-saga";

const SAGA_RESTORE_TIMEOUT = 300;

export default function forkWithErrHandler(saga: string, taskName: string, task: () => any) {
    return fork(function *() {
        while (true) {
            try {
                yield call(task);
                break;
            }
            catch (error) {
                yield put(trackError({
                    logLevel: LogLevel.Fatal,
                    category: saga,
                    message: `Uncaught error in ${taskName}`,
                    error: error
                }));

                yield delay(SAGA_RESTORE_TIMEOUT);
            }
        }
    });
}